<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head';
export default {
  name: 'App',
  setup() {
    useHead({
      title: 'Nizosoft',
      meta: [
        {
          name: 'description',
          content: 'We develop amazing apps for Android & iOS, create responsive websites, and provide powerful microservices for authentication, payments, and more.'
        }
      ]
    })
  },
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}

</style>
